export const gender = {
  1: "Nam",
  2: "Nữ"
}